enum QHPParentOrganizationSortingTypeEnum {
  AlphabeticalAsc = "Alphabetical (A-Z)",
  AlphabeticalDesc = "Alphabetical (Z-A)",
  NetworkCountDesc = "Network Count (high to low)",
  NetworkCountAsc = "Network Count (low to high)",
}

export { QHPParentOrganizationSortingTypeEnum };
